/* eslint-disable no-console */

import Freshpaint from 'freshpaint';

export namespace freshpaint {
  export const identify: Freshpaint['identify'] = function (...args) {
    console.debug('[Freshpaint Identify Called]', ...args);

    const [userId, traits] = args;
    if (!userId) {
      console.info('[Freshpaint Identify] Missing userId');
    }
    if (traits && typeof traits === 'object' && 'email' in traits) {
      console.info('[Freshpaint Identify] Email:', traits.email);
    }

    window?.freshpaint?.identify?.(...args);
  };

  export const track: Freshpaint['track'] = function (...args) {
    window?.freshpaint?.track?.(...args);
  };
}
